// Sync marketing short-link attribution after Firebase Auth sign-in.
// Call from any Scanbrix web app on *.scanbrix.com that shares this Firebase project.
import { marketingSyncAttributionCallable } from "./crmApi";

const COOKIE_LID = "sb_mkt_lid";
const LS_LID = "sb_mkt_lid";

function parseCookie(name) {
  if (typeof document === "undefined") return null;
  for (const part of document.cookie.split(";")) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const k = part.slice(0, idx).trim();
    if (k === name) return decodeURIComponent(part.slice(idx + 1).trim());
  }
  return null;
}

/** Read sb_mkt_lid from cookie (preferred) or localStorage. */
export function getMarketingLinkId() {
  const fromCookie = parseCookie(COOKIE_LID);
  if (fromCookie) return fromCookie;
  try {
    return localStorage.getItem(LS_LID);
  } catch {
    return null;
  }
}

/**
 * If the visitor arrived via /r/:slug, record signup or return visit on the marketing link.
 * Safe to call on every auth sign-in; deduped per browser session per user + link.
 */
export async function syncMarketingAttributionIfPresent(authUser) {
  if (!authUser?.uid) return { skipped: true, reason: "no_auth" };

  const linkId = getMarketingLinkId();
  if (!linkId) return { skipped: true, reason: "no_link_id" };

  const sessionKey = `sb_mkt_sync_${authUser.uid}_${linkId}`;
  try {
    if (sessionStorage.getItem(sessionKey)) return { skipped: true, reason: "already_synced_session" };
  } catch {
    /* ignore */
  }

  const fn = marketingSyncAttributionCallable();
  const res = await fn({ linkId });
  try {
    sessionStorage.setItem(sessionKey, "1");
  } catch {
    /* ignore */
  }
  return { ok: true, ...res.data };
}
